import { Culture } from '../../types';

export const fortMojave: Culture = {
  name: 'Fort Mojave Indian Tribe',
  languageFamily: 'Yuman-Cochimí',
  terms: [
    {
      word: 'Aha Makav',
      phonetic: 'ah-hah mah-kahv',
      description: 'Mojave name for themselves, meaning "People of the River."'
    },
    {
      word: 'Kuukuu',
      phonetic: 'koo-koo',
      description: 'Mojave word for "house" or "shelter."'
    },
    {
      word: 'Nyavely',
      phonetic: 'nyah-veh-lee',
      description: 'Mojave term for "sunrise" or "morning."'
    }
  ]
};